import React from "react"
import { Link } from "gatsby"

function NavMenuLink({ text, logo, url }) {
  // const linkToPage = () => {
  //   if (url) navigate(url)
  // }

  return (
    <Link
      to={url}
      activeClassName="text-[#3D41C2]"
      // onClick={linkToPage}
      className="flex gap-2 items-center cursor-pointer"
    >
      <div className="w-[60px]">
        <img className="w-full" src={logo} alt="" />
      </div>
      <p className="font-semibold">{text}</p>
      <div>{/* <img src={right_arrow_black} alt="" /> */}</div>
    </Link>
  )
}

export default NavMenuLink
